
import { Component, Vue, Prop } from 'vue-property-decorator'

import { showTitle } from '@/libs/util'
import CommonIcon from '_c/common-icon'

@Component({
    components: {
        CommonIcon
    }
})
export default class CustomBreadCrumb extends Vue {
    @Prop({ default: () => [] }) readonly list!: any[]
    @Prop({ default: 14 }) readonly fontSize!: number
    @Prop({ default: false }) readonly showIcon!: boolean

    name = 'customBreadCrumb'

    showTitle(item) {
        return showTitle(item, this)
    }
    isCustomIcon(iconName) {
        return iconName.indexOf('_') === 0
    }
    getCustomIconName(iconName) {
        return iconName.slice(1)
    }
    goTo(name) {
        this.$router['name'] = name
        this.$router.push({
            name: name
        })
    }
}
